<!-- Card Header Start-->

<!-- Card Header End-->
<div class="mb-5">
      <h1 class="font-medium text-[18px] leading-6 text-[#15191E]">Team Hours</h1>
      <p class="font-normal text-sm text-[#60646C] mt-2">Add and review your team's logged hours, including regular and overtime work.</p>
    </div>
<!-- Skeleton loader block -->
<ng-container *ngIf="loadSkelton()">
 <ngx-skeleton-loader
  count="6"
  appearance="line"`
  [theme]="{ height: '32px',width:'98%' , 'margin-bottom': '8px','margin-left': '1%' ,'border-radius': '6px' }"
  class="skeleton-loader">
</ngx-skeleton-loader>
</ng-container>


<mat-dialog-content *ngIf="!loadSkelton()" [ngClass]="isDialog? '!py-2 lg:!pb-6 lg:!px-6 !px-4 !pb-4' : '!p-0'">
  <div *ngIf="assigned()" class="border border-[#F1F1F4] rounded-lg">

    <cdk-accordion class="w-full">
      <cdk-accordion-item *ngFor="let item of assignees; let i = index" [expanded]="expandedIndex === i">

        <!-- Accordion Header Start -->
        <div
          class="flex justify-between lg:items-center items-start flex-col lg:flex-row gap-2.5 border-b border-[#EFF0F5] py-[14px] px-4 {{expandedIndex === i ? 'bg-[#FBFBFC]' : '' }}"
          tabindex="0" role="button"
          [attr.aria-expanded]="expandedIndex === i"
          [attr.aria-controls]="'accordion-body-' + i"
          [attr.id]="'accordion-header-' + i">


          <div class="flex items-center gap-2">
            <app-avatar [userList]="[{ displayName: item?.fullName , pic: item?.pic}]" [size]="'sm'" [showTooltip]="false" ></app-avatar>
            <h3 class="font-medium text-sm text-[#15191E]">{{ item.fullName }}</h3>
          </div>

          <div class="flex items-center flex-1 gap-2.5 w-full">

            <div class="min-w-[84px] flex lg:gap-2.5 gap-1.5 lg:flex-row flex-col flex-1 lg:justify-end justify-start items-start">
                <div class="min-w-[90px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#FEFCE8]">
                  <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                    Est:<span class="font-medium text-[#15191E] inline-block">{{ formatHeaderValue(item.emHours) }}h</span>
                  </p>
                </div>
                <div class="min-w-[118px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#EFF6FF]">
                  <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                    Regular:<span class="font-medium text-[#15191E] inline-block">{{ formatHeaderValue(getSumOfHours(item.rHours, '0').toString()) }}h</span>
                  </p>
                </div>
                <div class="min-w-[135px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#F0FDF4]">
                  <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                    Override:<span class="font-medium text-[#15191E] inline-block">{{ formatHeaderValue(getSumOfHours(item.rbHours, item.obHours).toString()) }}h</span>
                  </p>
                </div>
                <div class="min-w-[130px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#FAF5FF]">
                  <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                    Cost:<span class="font-medium text-[#15191E] inline-block">${{ getTotalCost(item.rRate, item.rbHours) + getTotalCost(item.otRate, item.obHours) }}</span>
                  </p>
                </div>
            </div>

          <div class="flex items-center lg:gap-2.5 gap-1">
            <!-- Save button only visible when expanded -->
            @if (expandedIndex === i) {
              <div *ngIf="!isCompleted" class="p-2 border border-[#C4CADA] flex justify-center items-center shrink-0 rounded-md cursor-pointer" matTooltip="Save"
                  (click)="onSubmitLaborHours(i)" (keydown.enter)="onSubmitLaborHours( i)" role="button" tabindex="0">
                <img ngSrc="../../../../../../assets/images/icons/ticket-detail/tick.svg" height="12" width="12"
                    alt="Save">
              </div>
            }
            <!-- Edit button visible when collapsed -->
            <div *ngIf="checkUserPermissions('write:changelabhrs')" class="p-2 border border-[#C4CADA] flex justify-center items-center shrink-0 rounded-md cursor-pointer" [matTooltip]="expandedIndex === i? 'Close' : 'Edit'"
                (click)="toggle(i)" (keydown.enter)="toggle(i)" role="button" tabindex="0">
              <img
                [ngSrc]="'../../../../../../assets/images/icons/ticket-detail/' + (expandedIndex === i ? 'Close' : 'edit') + '.svg'"
                height="12"
                width="12"
                [alt]="expandedIndex === i ? 'Close' : 'Edit'"
              />
            </div>
          </div>
          </div>

        </div>

        <!-- Accordion Body Start -->
        <div
          [@expandCollapse]="expandedIndex === i ? 'expanded' : 'collapsed'"
          role="region"
          [attr.id]="'accordion-body-' + i"
          [attr.aria-labelledby]="'accordion-header-' + i"
          class="overflow-hidden"
        >
          <div class="border-b border-[#EFF0F5] p-4">
            <div class="flex flex-col lg:flex-row gap-3">
              <div class="p-3 bg-[#EFF6FF] rounded-md flex-1">
                <h3 class="font-normal text-xs text-[#1D4ED8] leading-4 uppercase mb-2">Worker Hours</h3>
                <div class="flex gap-2">
                  <div class="flex-1">
                    <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                      <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                            for="WorkerRegular{{i}}">Regular</label>
                      <input type="text"
                            class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                            id="WorkerRegular{{i}}"
                            placeholder="Add Here"
                            (input)="onChangeRegularHours($event, i)"
                            [ngModel]="item.rHours ==='0'?'':item.rHours"
                            [maxLength]="6">
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                      <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                            for="WorkerOvertime{{i}}">Overtime</label>
                      <input type="text"
                            class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                            id="WorkerOvertime{{i}}"
                            placeholder="Add Here"
                            (input)="onChangeOverTimeHours($event, i)"
                            [ngModel]="item.otHours ==='0'?'':item.otHours"
                            [maxLength]="6">
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-3 bg-[#F0FDF4] rounded-md flex-1">
                <h3 class="font-normal text-xs text-[#15803D] leading-4 uppercase mb-2">Override Hours</h3>
                <div class="flex gap-2">
                  <div class="flex-1">
                    <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                      <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                            for="BillableRegular{{i}}">Regular</label>
                      <input type="text"
                            class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                            id="BillableRegular{{i}}"
                            placeholder="Add Here"
                            (input)="onChangeBillableRegularHours($event, i)"
                            [ngModel]="item.rbHours ==='0'?'':item.rbHours"
                            [maxLength]="6">
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                      <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                            for="BillableOvertime{{i}}">Overtime</label>
                      <input type="text"
                            class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                            id="BillableOvertime{{i}}"
                            placeholder="Add Here"
                            (input)="onChangeBillableOverTimeHours($event, i)"
                            [ngModel]="item.obHours ==='0'?'':item.obHours"
                            [maxLength]="6">
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-3 bg-[#FAF5FF] rounded-md flex-1">
                <h3 class="font-normal text-xs text-[#7E22CE] leading-4 uppercase mb-2">Rates</h3>
                <div class="flex gap-2">
                  <div class="flex-1">
                    <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                      <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                            for="RatesRegular{{i}}">Regular</label>
                      <input type="text"
                            class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                            id="RatesRegular{{i}}"
                            placeholder="Add Here"
                            (input)="onChangeRegularRate($event, i)"
                            [ngModel]="item.rRate ==='0'?'':item.rRate"
                            [maxLength]="6">
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                      <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                            for="RatesOvertime{{i}}">Overtime</label>
                      <input type="text"
                            class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                            id="RatesOvertime{{i}}"
                            placeholder="Add Here"
                            (input)="onChangeOverTimeRate($event, i)"
                            [ngModel]="item.otRate ==='0'?'':item.otRate"
                            [maxLength]="6">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </cdk-accordion-item>
    </cdk-accordion>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="lg:!p-1 !min-h-0">
</mat-dialog-actions>

